"use client";

import { getAuthToken } from "@dynamic-labs/sdk-react-core";
import {
  useMutation,
  type UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import { type Address } from "viem";

import { useAccount } from "#/store/wallet/account/account";

import { deleteReferral } from "../referrals.service";

type DeleteReferralPayload = {
  code: string;
  redeemerAddress: Address;
};

export const useDeleteReferral = (
  options?: UseMutationOptions<
    null | { deleted: boolean },
    Error,
    DeleteReferralPayload
  >,
) => {
  const queryClient = useQueryClient();
  const { account } = useAccount();

  return useMutation({
    ...options,
    mutationFn: async ({ code, redeemerAddress }) => {
      const token = getAuthToken();
      if (!token) {
        throw new Error("Authorization token not available");
      }

      const result = await deleteReferral({ token, code, redeemerAddress });

      if (result.error) {
        throw new Error(result.error.message);
      }

      return result.data;
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ["fetchReferralsByAccount", account],
      });
      options?.onSuccess?.(...args);
    },
  });
};
